export type FileBatchResult<FileId, Content> =
	| { fileId: FileId; status: "success"; content: Content }
	| { fileId: FileId; status: "error"; error: unknown };

export const getFilesContentInBatches = async <FileId, Content>({
	fileIds,
	batchSize = 5,
	retries = 1,
	getContent,
}: {
	fileIds: FileId[];
	batchSize?: number;
	retries?: number;
	getContent: (fileId: FileId) => Promise<Content>;
}): Promise<FileBatchResult<FileId, Content>[]> => {
	if (batchSize < 1) {
		throw new Error("batchSize must be greater than 0");
	}

	const results: FileBatchResult<FileId, Content>[] = [];

	for (
		let fileIds_index = 0;
		fileIds_index < fileIds.length;
		fileIds_index += batchSize
	) {
		const batch = fileIds.slice(fileIds_index, fileIds_index + batchSize);
		const batchResults = await Promise.all(
			batch.map(async (fileId): Promise<FileBatchResult<FileId, Content>> => {
				let lastError: unknown;
				for (let attempt = 0; attempt <= retries; attempt++) {
					try {
						const content = await getContent(fileId);
						return { fileId, status: "success", content };
					} catch (err) {
						lastError = err;
					}
				}
				return { fileId, status: "error", error: lastError };
			}),
		);
		results.push(...batchResults);
	}

	return results;
};
